import { SCHEDULED_TEMPLATE_PREFIX, TEMPLATE_ASSIGNED, TEMPLATE_ORIGIN } from './template';
import { PROVIDER_CONFIG } from './providerConfig';
import { ProviderSource } from '~/types/template';

/** Gempages V7 */
export const regexTemplateV7 = new RegExp(
  `^templates/(${TEMPLATE_ORIGIN.join('|')})\\.(gp-template-[0-9]+)\\.(json|liquid)$`,
);
export const regexTemplateIdV7 = new RegExp('.*?gp-template-(.+[0-9])(?:\\.(.*?))?$');

export const regexTemplateGPDefault = new RegExp(
  `^templates/(${TEMPLATE_ORIGIN.join('|')})\\.(gp-template-bk-default)\\.(json|liquid)$`,
);

/** Gempages V6 */
export const regexTemplateV6 = new RegExp(
  `^templates/(${TEMPLATE_ORIGIN.join('|')})\\.(gem-\\d+-template)\\.(json|liquid)$`,
);
export const regexTemplateIdV6 = new RegExp('.*?gem-(.+?)-template(?:\\.(.*?))?$');

export const regexTemplateGemX = new RegExp(
  `^templates/(${TEMPLATE_ORIGIN.join('|')})\\.(${PROVIDER_CONFIG[ProviderSource.SHOPIFY_GEMX].prefix}.+?)\\.(json|liquid)$`,
);
export const regexTemplatePageFly = new RegExp(
  `^templates/(${TEMPLATE_ORIGIN.join('|')})\\.(${PROVIDER_CONFIG[ProviderSource.SHOPIFY_PAGE_FLY].prefix}.+?)\\.(json|liquid)$`,
);

export const regexTemplateFoxify = new RegExp(
  `^templates/(${TEMPLATE_ORIGIN.join('|')})\\.(${PROVIDER_CONFIG[ProviderSource.SHOPIFY_FOXIFY].prefix}.+?)\\.(json|liquid)$`,
);

export const regexTemplateEComposer = new RegExp(
  `^templates/(${TEMPLATE_ORIGIN.join('|')})\\.(${PROVIDER_CONFIG[ProviderSource.SHOPIFY_ECOMPOSER].prefix}.+?)\\.(json|liquid)$`,
);

export const regexTemplateShogun = new RegExp(
  `^templates/(${TEMPLATE_ORIGIN.join('|')})\\.${PROVIDER_CONFIG[ProviderSource.SHOPIFY_SHOGUN].prefix}\\.(.+?)\\.(json|liquid)$`,
);

export const regexTemplateOrigin = new RegExp(
  `^templates/(${TEMPLATE_ORIGIN.join('|')})\\.(json|liquid)$`,
);

export const regexTemplateShopify = new RegExp(
  `^templates/(${TEMPLATE_ORIGIN.join('|')})\\.(.+?)\\.(json|liquid)$`,
);

export const TEMPLATE_IGNORE = ['gem-backup-default'];

export const regexTemplateIgnore = new RegExp(
  `templates/(${TEMPLATE_ORIGIN.join('|')}).(${TEMPLATE_IGNORE.join('|')}).(json|liquid)`,
);

/** Transient files GemPages' scheduled-publish job uploads to Shopify — see {@link SCHEDULED_TEMPLATE_PREFIX}. */
export const regexTemplateScheduled = new RegExp(
  `^templates/(${TEMPLATE_ORIGIN.join('|')})\\.(${SCHEDULED_TEMPLATE_PREFIX}-.+?)\\.(json|liquid)$`,
);

export const regexTemplateSupport = new RegExp(`^templates/(${TEMPLATE_ASSIGNED.join('|')}).*?$`);
